<template>
  <az-container>
    <ModalVisualizarRespostaEsclarecimentoImpugnacao
      v-if="modalVisualizacao"
      v-model="modalVisualizacao"
      @fecharModalVisualizacao="fecharModalVisualizacao"
      :item="esclarecimentoSelecionado"
    />
    <ModalResponderEsclarecimentoImpugnacao
        v-if="modalResposta"
        v-model="modalResposta"
        @fecharModal="fecharModalResponder"
        :item="esclarecimentoSelecionado"
        tipo="Impugnação"
        :esclarecimento="false"
        :convidado="true"
    />
    <div class="pb-5">
      <az-toolbar>
        <template #simpleSearch>
          <EsclarecimentoImpugnacaoFiltro
            :filtros.sync="filtrosInterno"
            :situacoes="situacoes"
            searchId="impugnacao-convidado-search"
            assuntoLabel="Assunto da impugnação"
            @advanced-search="onAdvancedSearch"
            @simple-search="eventoBuscaSimples"
            @clear="eventoLimpar"
          />
        </template>
      </az-toolbar>
    </div>


    <div class="az-form-content licitacao-esclarecimento-usuario-convidado">
      <LicitacaoEsclarecimentoImpugnacaoUsuarioConvidadoTabela
        ref="tabelaConvidado"
        :filtros="filtrosInterno"
        tipo="IMPUGNACAO"
        @abrir-visualizacao="abrirModalVisualizacao"
        @abrir-resposta="abrirModalResposta"
      />
    </div>
  </az-container>
</template>

<script>
import ModalVisualizarRespostaEsclarecimentoImpugnacao from './Modal/ModalVisualizarRespostaEsclarecimentoImpugnacao'
import ModalResponderEsclarecimentoImpugnacao
  from "@/views/licitacao/detalhe/orgao/EsclarecimentoImpugnacao/Modal/ModalResponderEsclarecimentoImpugnacao.vue";
import LicitacaoEsclarecimentoImpugnacaoUsuarioConvidadoTabela from './LicitacaoEsclarecimentoImpugnacaoUsuarioConvidadoTabela.vue'
import EsclarecimentoImpugnacaoFiltro from './EsclarecimentoImpugnacaoFiltro.vue'

export default {
  name: 'LicitacaoImpugnacaoUsuarioConvidado',
  components: {
    ModalResponderEsclarecimentoImpugnacao,
    ModalVisualizarRespostaEsclarecimentoImpugnacao,
    LicitacaoEsclarecimentoImpugnacaoUsuarioConvidadoTabela,
    EsclarecimentoImpugnacaoFiltro
  },
  data() {
    return {
      usuarioIdDisplay: null,
      carregando: false,
      modalVisualizacao: false,
      modalResposta: false,
      esclarecimentoSelecionado: null,
      filtrosInterno: {
        empresa: '',
        assunto: '',
        processo: '',
        edital: '',
        orgao: '',
        objeto: '',
        situacao: ''
      },
      situacoes: {
        AGUARDANDO: 'AGUARDANDO',
        RESPONDIDO: 'RESPONDIDO',
      }
    }
  },
  computed: {
    filtrosAtivos() {
      const ativos = {}
      Object.keys(this.filtrosInterno).forEach(k => {
        if (this.filtrosInterno[k]) {
          ativos[k] = { value: this.filtrosInterno[k], valueTruncated: this.filtrosInterno[k] }
        }
      })
      return ativos
    }
  },
  mounted() {
  },
  methods: {
    onAdvancedSearch() {
      if (this.$refs.tabelaConvidado && this.$refs.tabelaConvidado.carregarLista) {
        this.$refs.tabelaConvidado.carregarLista()
      }
    },
    eventoBuscaSimples(valor) {
      this.filtrosInterno.processo = valor
       if (this.$refs.tabelaConvidado && this.$refs.tabelaConvidado.carregarLista) {
         this.$refs.tabelaConvidado.carregarLista()
       }
     },
    eventoLimpar() {
      this.filtrosInterno = { empresa: '', assunto: '', processo: '', edital: '', orgao: '', objeto: '', situacao: '' }
      if (this.$refs.tabelaConvidado && this.$refs.tabelaConvidado.carregarLista) {
        this.$refs.tabelaConvidado.carregarLista()
      }
    },
    criarLinkDownload(uri) {
      if (!uri) return null
      return uri.startsWith('http') ? uri : (uri.startsWith('/') ? uri : ('/' + uri))
    },
    refresh() {
      if (this.$refs.tabelaConvidado && this.$refs.tabelaConvidado.carregarLista) {
        this.$refs.tabelaConvidado.carregarLista()
      }
    },
    abrirModalVisualizacao(item) {
      this.esclarecimentoSelecionado = item
      this.modalVisualizacao = true
    },
    abrirModalResposta(item) {
      this.modalResposta = true
      this.esclarecimentoSelecionado = item
    },
    fecharModalVisualizacao() {
      this.modalVisualizacao = false
      this.esclarecimentoSelecionado = null
    },
    fecharModalResponder() {
      this.modalResposta = false
      this.esclarecimentoSelecionado = null
      if (this.$refs.tabelaConvidado && this.$refs.tabelaConvidado.carregarLista) {
        this.$refs.tabelaConvidado.carregarLista()
      }
    }
  }
}
</script>

<style scoped>
.licitacao-esclarecimento-usuario-convidado {
  min-height: 20vh;
  padding: 16px; /* adiciona padding ao componente */
}
</style>
